import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Pickup } from './pickup';
import { User } from './user';

@Component({
  selector: 'app-pickup',
  templateUrl: './pickup.component.html',
  styleUrls: ['./pickup.component.css']
})
export class PickupComponent implements OnInit {

  pickupId: string;
  pickup: FirebaseObjectObservable<Pickup>;
  user: FirebaseObjectObservable<User>;

  constructor(
    private route:    ActivatedRoute,
    private location: Location,
    private db:       AngularFireDatabase
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.getPickup(params.id);
      this.pickupId = params.id;
    });
  }

  private getPickup(pickupId: string) {
    console.log('pickup id', pickupId);
    this.db.object('/pickups/' + pickupId).subscribe(
      data => {
        console.log('pickup data', data);
        data.locationUrl = this.UrlBuilder(data.latitude, data.longitude);
        this.pickup = data;
        this.getUser(data.userId);
      }
    );
  }

  private getUser(userId: string) {
    console.log('user id', userId);
    this.db.object('/users/' + userId).subscribe(
      data => {
        console.log('user data', data);
        this.user = data;
      }
    );
  }

  private UrlBuilder(latitude: number, longitude: number): string {
    return 'http://kart.1881.no/?lat=' + latitude + '&lon=' + longitude + '&z=15';
  }

  markAsPickedUp() {
    this.db.object('/pickups/' + this.pickupId).update( { 'pickedUp': true } )
  }

}



// WEBPACK FOOTER //
// ./src/app/pickup/pickup.component.ts